import { i18n } from 'arm-common';
import React, { Component } from 'react'

/**
 * @augments {Component<{show: boolean, width:string, marginRight: string, marginLeft:string, marginBottom: string, marginTop: string}, State>}
 */
class ConfirmModalOkCancelV4 extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        if (!this.props.show)
            return null;
        return (
            <div>
                {/*<!-- ConfirmModalOkCancelV4 -->*/}
                <div className={"modal d-block"}  id={this.props.id}>
                    <div className={"modal-dialog " + (this.props.className ? " " + this.props.className : "")}>
                        <div className="modal-content">
                            {this.props.children}
                        </div>
                    </div>
                </div>
                <div className="modal-backdrop show"></div>
            </div>
        )
    }
}

/**
 * @augments {Component<{onClose: function}, State>}
 */
class Header extends Component {
    render() {
        {/** Titolo del popup */ }
        return <div className={"modal-header  bg-light" + (this.props.className ? this.props.className : "")} >
            {this.props.children}
            <p className={"modal-title font-weight-bold" + (this.props.classNameTitle ? " " + this.props.classNameTitle : "")}>
                {(this.props.testoTitle !== undefined && this.props.testoTitle !== null) ?
                    this.props.testoTitle
                    : "Conferma"
                }
            </p>
            <button type="button" className="close" data-dismiss="modal" onClick={this.props.onClose}>
                <span>&times;</span>
            </button>
        </div>
    }
}

/**
 * @augments {Component<{maxHeight: string}, State>}
 */
class Body extends Component {
    render() {
        {/** Da inserire qua il contenuto del popup */ }
        return <div className={"modal-body" + (this.props.className ? " " + this.props.className : "")}>
            {this.props.children}
            <p className={"modal-title font-weight-normal" + (this.props.classNameTesto ? " " + this.props.classNameTesto : "")}>
                {(this.props.testoBody !== undefined && this.props.testoBody !== null) ?
                    this.props.testoBody
                    : "Conferma"
                }
            </p>
        </div>
    }
}

/**
 * @augments {Component<{}, State>}
 */
class Footer extends Component {
    render() {
        {/**Da inserire qua il contenuto per il footer del popup */ }
        return <div className={"modal-footer bg-light d-flex justify-content-between" + (this.props.className ? " " + this.props.className : "")} >
            <button type="button" id={this.props.IdConfirm} className={" " + (this.props.classNameTestoButtonConfirm ? " " + this.props.classNameTestoButtonConfirm : "btn btn-primary")} onClick={this.props.confirmOnClick}>
                <i className={this.props.classNameIconConfirm ? this.props.classNameIconConfirm : "fas fa-save "} /> {(this.props.testoButtonConfirm !== undefined) ? " " + this.props.testoButtonConfirm : " Conferma"}
            </button>

            {this.props.children}

            <button type="button" id={this.props.IdCancel} className={" " + (this.props.classNameTestoButtonCancel ? this.props.classNameTestoButtonConfirm : "btn btn-secondary")} data-dismiss="modal" onClick={this.props.onClose} >
                <i className={this.props.classNameIconCancel ? this.props.classNameIconCancel : "far fa-times-circle "} /> {(this.props.testoButtonCancel !== undefined) ? " " + this.props.testoButtonCancel :  i18n('ARM_CORE_PRODUCT.SHARED.ANNULLA', 'Annulla')}
            </button>
        </div>
    }
}

ConfirmModalOkCancelV4.Header = Header;
ConfirmModalOkCancelV4.Body = Body;
ConfirmModalOkCancelV4.Footer = Footer;

export default ConfirmModalOkCancelV4;